import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Backdrop').create(() => ({
  root: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: '50',
  },
}))
